(function(api) {
	
	api.GetPrisutnostiSync = GetPrisutnostiSync;
	api.GetPrisutnostiFieldsJSONSync = GetPrisutnostiFieldsJSONSync;	
	api.GetPrisutnosti = GetPrisutnosti;
	api.UpdatePrisutnosti = UpdatePrisutnosti;
	api.UpdatePrisutnostiStavke = UpdatePrisutnostiStavke;
	api.UpdatePrisutnostiVRada = UpdatePrisutnostiVRada;
	api.ObrisiStavku = ObrisiStavku;
	api.ObrisiStavke = ObrisiStavke;
	api.ObrisiStavkeZaDan = ObrisiStavkeZaDan;
	api.ObrisiStavkeZaRadnikDan = ObrisiStavkeZaRadnikDan;
	api.GenerirajRadnaVremena = GenerirajRadnaVremena;
	api.StavkaPRVezaDodaj = StavkaPRVezaDodaj;
	api.StavkaPRVezaObrisi = StavkaPRVezaObrisi;
	api.ObrisiPrisutCitac = ObrisiPrisutCitac;
	
	api.GetPrisutnostData = GetPrisutnostData;
	api.Autoriziraj = Autoriziraj;
	api.PrisutProvjere = PrisutProvjere;
	
	api.GetOdobravanje = GetOdobravanje;
	api.SaveRMjesto = SaveRMjesto;
	
	api.DajPrisutRZaRadnikDan = DajPrisutRZaRadnikDan;

	api.GetZahtjevSFields = GetZahtjevSFields;
	api.ZahtjevSObrisi = ZahtjevSObrisi;
	api.GetPovijestSFields = GetPovijestSFields;
	api.ProvjeriSalda = ProvjeriSalda;
	api.SetStatusZahtjeva = SetStatusZahtjeva;

	api.PrisutCitacObrisi = PrisutCitacObrisi;
	api.ProvjeriUlazPrisut = ProvjeriUlazPrisut;
	api.UgovorByKlasa = UgovorByKlasa;
	api.ZahtjevSIzmjeniKolicinu = ZahtjevSIzmjeniKolicinu;
	
	api.RadnikByOIB = RadnikByOIB;
	api.GetUgovorTemplate = GetUgovorTemplate;
	api.OdobriNeOdobriUgovor = OdobriNeOdobriUgovor;
	api.OtvoriPraznuBanku = OtvoriPraznuBanku;
	api.GenerirajNejednako = GenerirajNejednako;
	
	function GenerirajNejednako(iRadnik, iPrisut, iDan){
			return $.dsDirectCall({
				method: "od/GenerirajNejednako",
				params: [ iRadnik, iPrisut, iDan ]
			});
		}
	
	function OtvoriPraznuBanku(iban, otvori){
		return $.dsDirectCall({
			method: "od/OtvoriPraznuBanku",
			params: [ iban, otvori ]
		});
	}
	
	function OdobriNeOdobriUgovor(ugovor){
		return $.dsDirectCall({
			method: "OdobriNeOdobriUgovor",
			params: [ ugovor ]
		});
	}
	
	function GetUgovorTemplate(rjesenje){
		return $.dsDirectCall({
			method: "GetUgovorTemplate",
			params: [ rjesenje ]
		});
	}
	
	function RadnikByOIB(oib){
		return $.dsDirectCall({
			method: "RadnikByOIB",
			params: [ oib ]
		});
	}
	
	function UgovorByKlasa(klasa){
		return $.dsDirectCall({
			method: "UgovorByKlasa",
			params: [ klasa ]
		});
	}
	
	function ZahtjevSIzmjeniKolicinu(zahtjevs, kolicina){
		return $.dsDirectCall({
			method: "ZahtjevSIzmjeniKolicinu",
			params: [ zahtjevs, kolicina ]
		});
	}
	
	function GetZahtjevSFields(){
		return $.dsDirectCall({
			method: "GetZahtjevSFields"
		});
	}
	
	function ZahtjevSObrisi(zahtjevs){
		return $.dsDirectCall({
			method: "ZahtjevSObrisi",
			params: [ zahtjevs ]
		});
	}
	
	function GetPovijestSFields(){
		return $.dsDirectCall({
			method: "GetPovijestSFields"
		});
	}
	
	function ProvjeriSalda(zahtjev, javiGresku){
		if (javiGresku == undefined) javiGresku = false;
		return $.dsDirectCall({
			method: "ProvjeriSalda",
			params: [ zahtjev ]
		});
	}
	
	function SetStatusZahtjeva(zahtjev, status, poruka){
		return $.dsDirectCall({
			method: "SetStatusZahtjeva",
			params: [ zahtjev, status, poruka ]
		});
	}

	function GetPrisutnostData(url) {
		return	$.dsDirectCall({
        	method: url
      	});
	}

	function GetPrisutnostiSync(dataParams) { //ne koristi se?!
		return	$.dsDirectCallSync({//sync
        	method: "GetPrisutnosti?" + jQuery.param(dataParams)
      	});
	}
	function GetPrisutnostiFieldsJSONSync(dataParams) { //ne koristi se?!
		return	$.dsDirectCallSync({//sync
        	method: "GetPrisutnosti?" + jQuery.param(dataParams)
      	});
	}

	
	function GetPrisutnosti(dataParams) {
		return	$.dsDirectCall({
        	method: "GetPrisutnosti?" + jQuery.param(dataParams)
      	});
	}
	
	function UpdatePrisutnosti(data, errorCB, doneCB) {
		return $.ajax({
	        url: kontorouter.getModulPath('prisut/prisutnostiUpdate'),
	        type: "POST",
	        data: data,
	        dataType: "json",
	    })
	    .error(errorCB)
	    .done(doneCB);
	}
	
	function UpdatePrisutnostiVRada(data, errorCB, doneCB) {
		return $.ajax({
	        url: kontorouter.getModulPath('prisut/prisutnostiUpdateVRada'),
	        type: "POST",
	        data: data,
	        dataType: "json",
	    })
	    .error(errorCB)
	    .done(doneCB);
	}
	
	function UpdatePrisutnostiStavke(data, errorCB, doneCB) {
		return $.ajax({
	        url: kontorouter.getModulPath('prisut/prisutnostiStavkeUpdate'),
	        type: "POST",
	        data: data,
	        dataType: "json",
	    })
	    .error(errorCB)
	    .done(doneCB);
	}
	
	
	function ObrisiStavku(prisutRS) {
        return $.dsDirectCall({
            method: "PrisutRSObrisi",
            params: [prisutRS],
        });
	}
	
	function ObrisiStavkeZaDan(prisutR) {
        return $.dsDirectCall({
            method: "ObrisiStavkeZaDan",
            params: [prisutR],
        });
	}
	function ObrisiStavkeZaRadnikDan(radnik, dan, prisut) {
        return $.dsDirectCall({
            method: "ObrisiStavkeZaRadnikDan",
            params: [radnik, dan, prisut],
        });
	}
	
	function ObrisiStavke(dataParams) {		
		return $.dsDirectCall({
            method: "ObrisiStavke",
    		params: [JSON.stringify(dataParams)]
        });
	}	
	
	function GenerirajRadnaVremena(dataParams) {
		return $.dsDirectCall({ 
            method: "GenerirajRadnoVrijeme" ,
            params: [dataParams]
        });
	}
	
	function StavkaPRVezaDodaj (PRVeza, prisutRS) {
    	return $.dsDirectCall({
            method: "StavkaPRVezaDodaj",
            params: [PRVeza, prisutRS]
        });
	}
	
	function StavkaPRVezaObrisi (prisutRS) {
    	return $.dsDirectCall({
            method: "StavkaPRVezaObrisi",
            params: [prisutRS]
        });
	}
	
	function ObrisiPrisutCitac (prisutCitac) {
    	return $.dsDirectCall({
            method: "PrisutCitacObrisi",
            params: [prisutCitac]
        });
	}
	
	function Autoriziraj(prisut) {
		return $.dsDirectCall({
            method: "Autoriziraj",
            params: [prisut]
        });
	}
	function PrisutProvjere(prisut) {
		return $.dsDirectCall({
            method: "PrisutProvjere",
            params: [prisut]
        });
	}
	
	
	//dodano matej
	function GetOdobravanje(){
		return $.dsDirectCall({
			method: "GetOdobravanje"
		});
	}

	function SaveRMjesto(rmjesto, sortRMjesto) {
		return $.dsDirectCall({
            method: "SaveRMjesto",
            params: [rmjesto,sortRMjesto]
        })
        .done(alert('Parametar će biti do kraja aktivan nakon sljedeće prijave!'));
	}
	
	function DajPrisutRZaRadnikDan(iRadnik, iDan, iPrisut) { //ne koristi se?!
		return $.dsDirectCall({
            method: "DajPrisutRZaRadnikDan",
            params: [iRadnik, iDan, iPrisut]
        });
	}
	
	function PrisutCitacObrisi(prisutCitac) {
        return $.dsDirectCall({
            method: "PrisutCitacObrisi",
            params: [prisutCitac],
        });
	}
	function ProvjeriUlazPrisut(iPrisut, iVrsta) {
		return $.dsDirectCall({
            method: "ProvjeriUlazPrisut",
            params: [iPrisut, iVrsta]
        });
	}
	
	
  	
} (konto.od.api = {}));